import { RootState } from "@/redux/store";
import { useGetVendorsGlSpend } from "@/services";
import { useSelector } from "react-redux";

const useOperational = () => {
  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const currentFinanceYear = useSelector(
    (state: RootState) => state.currentData.currentFinanceYear
  );

  const { data: vendorGlData, isLoading: isVendorGlDataLoading } =
    useGetVendorsGlSpend({
      communityId: communityDetail?.communityId,
      year: currentFinanceYear,
      queryParams: {
        enabled: !!(communityDetail?.communityId && currentFinanceYear),
      },
    });

  return {
    vendorGlData,
    isVendorGlDataLoading,
  };
};

export default useOperational;
